import { Edit } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormGroupUpdate from '../Forms/FormGroupUpdate';

export default function UpdateGroup(props: { groupe: any, handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <IconButton tooltip="Modifier ce groupe utilisateur" size={28} color="warning" onClick={() => setOpen(true)}><Edit size={16} /></IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`Modification du groupe ${props.groupe?.Libelle || ''}`}
                hint="Ajustez le libellé et les habilitations du groupe puis enregistrez."
            >
                <FormGroupUpdate handleFunction={() => { setOpen(false); props.handleFunction() }} groupe={props.groupe} />
            </FormDrawer>
        </div>
    );
}
